/**
 * Rejects with `message` if `promise` hasn't settled within `ms`.
 * Used to guard Auth0 calls that can hang indefinitely (e.g. an iframe-based
 * silent auth check that never resolves when third-party cookies are blocked),
 * so a stuck promise turns into a visible error instead of an infinite spinner.
 */
export const withTimeout = <T>(
  promise: Promise<T>,
  ms: number,
  message: string
): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    const timeoutId = setTimeout(() => reject(new Error(message)), ms);

    promise
      .then(value => {
        clearTimeout(timeoutId);
        resolve(value);
      })
      .catch(error => {
        clearTimeout(timeoutId);
        reject(error);
      });
  });
};
